// .

export const environment = {
  production: true,
  name: 'dev',
  logging: {
    console: true,
    appInsights: false
  },
  apiServer: {
    baseUrl: 'https://despacho-dev.aeroplantas.com.ar/api',
    ranchosBaseUrl: 'https://ranchos-dev.aeroplantas.com.ar/api',
    tradersBaseUrl: 'https://traders-dev.aeroplantas.com.ar/api',
    facturacionBaseUrl: 'https://facturacion-dev.aeroplantas.com.ar/api',
    stockBaseUrl: 'https://stock-dev.aeroplantas.com.ar/api',
    reportesUrl: 'https://reportes-dev.aeroplantas.com.ar/api',
    productosUrl:'https://productos-dev.aeroplantas.com.ar/api',
    clientesBaseUrl:'https://clientes-dev.aeroplantas.com.ar/api',
    usuariosBaseUrl:'https://usuarios-dev.aeroplantas.com.ar/api',
    notificacionesBaseUrl: 'https://notificaciones-dev.aeroplantas.com.ar/api',
    cierreTurnoBaseUrl: 'https://cierreturno-dev.aeroplantas.com.ar/api',
  },
  signalR: {
    activarFuncionalidad: true,
    signalRUrl: 'https://comunicaciones-dev.aeroplantas.com.ar/notify'
  },
  grafana: {
    preciosUtilizados: 'https://dev.aeroplantas.com.ar/grafana/d/j2SbesSnz/precios-utilizados-dev?orgId=1&from=1600190535585&to=1631726535586&theme=light',
    reporteMovimientosProductos:'https://dev.aeroplantas.com.ar/grafana/d/ZVfVF4A7z/reporte-movimiento-productos-stock-dev?orgId=1'
  },
  frontdoor: {
    timeout: 240000
  },
  apiManagement: {
    interfazSAP: "https://pad-prod.azure-api.net/DWH/GetInterfazSAP",
    interfazMonitorAsientos: "https://prod-17.brazilsouth.logic.azure.com:443/workflows/28df4ab2ee2942f9893580a0ce29077f/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=Dl_WqoHQmwzSgF2sfRMrbVg3s43i0bMLcK7OIYIaGMk",
    interfazStock: "https://pad-prod.azure-api.net/DWH/GetInterfazStock",
    interfazDocumentosComerciales: "https://pad-prod.azure-api.net/DWH/GetInterfazDocumentosComerciales"
  },

  authentication: {
    authority: 'https://login.microsoftonline.com/1c6baf84-0047-49ef-bb6f-1528e354dbfb/v2.0',
    client_id: 'c11484b7-7d97-451f-9f44-0c34f7aca9b4',
    redirect_uri: 'https://dev.aeroplantas.com.ar/auth-callback',
    post_logout_redirect_uri: 'http://dev.aeroplantas.com.ar/',
    response_type: 'code',
    loadUserInfo: false,
    scope: 'openid profile email api://c11484b7-7d97-451f-9f44-0c34f7aca9b4/pad-despacho-api',
    automaticSilentRenew: true,
    silent_redirect_uri: 'https://dev.aeroplantas.com.ar/silent-refresh.html',
    userinfoEndpoint: 'https://graph.microsoft.com/oidc/userinfo',
    registrationEndpoint: 'https://login.microsoftonline.com/1c6baf84-0047-49ef-bb6f-1528e354dbfb/v2.0'
  }

  /*authentication: {
    authority: "https://magui-test.ypf.com",
    client_id: "f47f8acc-79cf-4aef-937a-b582f06309d5",
    response_type: "token",
    scope: "interno proveedor openid user.read profile email jwt",
    redirect_uri: 'https://dev.aeroplantas.com.ar/auth-callback',
    post_logout_redirect_uri: 'http://dev.aeroplantas.com.ar/',
    silent_redirect_uri: 'https://dev.aeroplantas.com.ar/silent-refresh.html',
    userinfoEndpoint : "https://magui-test.ypf.com/openid/connect/v1/userinfo",
    registrationEndpoint : "https://magui-test.ypf.com/openid/connect/register",
    loadUserInfo: false,
    automaticSilentRenew: true,
    includeIdTokenInSilentRenew: false
  }*/
};
